import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";

interface Props {
    label: string
    value: string
}

const BasicDashboardItem = ({ label, value }: Props) => {
    return (
        <Box flex={1 / 4}>
            <KTCard className='dashboard-kpi'>
                <Box p='15px'>
                    <Box flexDirection='row'>
                        <Box justifyContent='center'>
                            <i style={{ color: '#535353', fontSize: '18px' }} className='fa fa-users' />
                        </Box>
                        <Box ml='10px' justifyContent='center'>
                            <h3 style={{ color: '#535353' }} className='m-0 p-0'>{label}</h3>
                        </Box>
                    </Box>

                    <Box mt='15px' flexDirection='row'>
                        <Box flexGrow={1} justifyContent='center'>
                            &nbsp;
                        </Box>
                        <Box justifyContent='center'>
                            <h1 style={{ fontSize: '40px', color: '#1B84FF' }} className='m-0 p-0'>{value}</h1>
                        </Box>
                        <Box ml='10px' justifyContent='center'>
                            <i style={{ color: '#17c653', fontSize: '18px' }} className='fa fa-chevron-up' />
                        </Box>
                    </Box>
                </Box>
            </KTCard>
        </Box>
    )
}

export default BasicDashboardItem;